var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 152v345c0 8.284 6.716 15 15 15h482c8.284 0 15-6.716 15-15v-345l-19.233-10h-472.769z",
    fill: "#f5f2f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 152v345c0 8.28-6.72 15-15 15h-241v-370h236.77z",
    fill: "#e8e1de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 47c0-8.284-6.716-15-15-15h-482c-8.284 0-15 6.716-15 15v105h512z",
    fill: "#f47160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 47v105h-256v-120h241c8.28 0 15 6.72 15 15z",
    fill: "#fc5832"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#55696e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m76 0c-8.284 0-15 6.716-15 15v52c0 8.284 6.716 15 15 15s15-6.716 15-15v-52c0-8.284-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166 0c-8.284 0-15 6.716-15 15v52c0 8.284 6.716 15 15 15s15-6.716 15-15v-52c0-8.284-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-8.284 0-15 6.716-15 15v52c0 8.284 6.716 15 15 15s15-6.716 15-15v-52c0-8.284-6.716-15-15-15z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m271 15v52c0 8.28-6.72 15-15 15v-82c8.28 0 15 6.72 15 15z",
    fill: "#495959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346 0c-8.284 0-15 6.716-15 15v52c0 8.284 6.716 15 15 15s15-6.716 15-15v-52c0-8.284-6.716-15-15-15z",
    fill: "#495959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436 0c-8.284 0-15 6.716-15 15v52c0 8.284 6.716 15 15 15s15-6.716 15-15v-52c0-8.284-6.716-15-15-15z",
    fill: "#495959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166 227h-60c-8.284 0-15 6.716-15 15v60c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15z",
    fill: "#dbd1cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406 227h-60c-8.284 0-15 6.716-15 15v60c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15z",
    fill: "#c6bbb6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286 346h-60c-8.284 0-15 6.716-15 15v60c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15z",
    fill: "#dbd1cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301 361v60c0 8.28-6.72 15-15 15h-30v-90h30c8.28 0 15 6.72 15 15z",
    fill: "#c6bbb6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286 227h-60c-8.284 0-15 6.716-15 15v60c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15z",
    fill: "#dbd1cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301 242v60c0 8.28-6.72 15-15 15h-30v-90h30c8.28 0 15 6.72 15 15z",
    fill: "#c6bbb6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406 346h-60c-8.284 0-15 6.716-15 15v60c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15z",
    fill: "#c6bbb6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.462 360.161c-6.428-5.226-15.875-4.25-21.101 2.176l-30.498 37.513-8.352-6.849c-6.406-5.255-15.857-4.318-21.11 2.087-5.253 6.406-4.318 15.857 2.088 21.11l20 16.4c6.438 5.28 15.922 4.295 21.15-2.136l40-49.2c5.226-6.428 4.251-15.875-2.177-21.101z",
    fill: "#50dbc1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.e235de0f319610fdd2397d6575c4559e.svg";
export { ForwardRef as ReactComponent };